import axios from "axios";
import OpenAI from "openai";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";

export const transcribeAudio = async ( formData: FormData ): Promise<any> => {

  try {
    let token = await getAuthToken();
  if(token){
      let header_token = "Bearer " + token.data;
      const headers = {
          Authorization: header_token,
      };
    let endpoint = `${baseUrl}/core/speech-to-text/transcribe/`
    const response = await axios.post(endpoint, formData, {headers});

    if (!response?.data) {
    return{success:false, data: response}

    }
    console.log('transcribed response', response);
    return{success:true, data: response}
  } else{
    return{success:false, data: 'Token not found'}

  }
  } catch (error) {
    console.error("File upload error:", error);
    return{success:false, data: error}

  }
};



export const getAISuggestionForLead = async (leadContext: string, orgId: string) => {
  let token = await getAuthToken();
  if(token){
      let header_token = "Bearer " + token.data;
      const headers = {
          Authorization: header_token,
      };
  let data = {
    context : leadContext
  }
  try {
    let response = await axios.post(`${baseUrl}/core/organizations/${orgId}/leads/19/suggestions/get_lead_suggestion/`, data, { headers });
    if(response.status>=200 && response.status<400){
      return{success:true, data: response?.data}
    }else{
      return{success:false, data: response?.data}
    }
  } catch (err: any) {
    console.error("OpenAI API error:", err);
    return {
      success: false,
      data: err.message,
    };
  }
}else{
      return{success:false, data: 'An error occured.'}
}};

